import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconText1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="text-1"><path d="M3.75 6.25V3.75H12H20.25V6.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 20.25V3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9.75 20.25H12H14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconText1;
